'use client'

import { useState } from 'react'
import InvoiceForm from './InvoiceForm'

export default function DocumentTabs() {
  const [activeTab, setActiveTab] = useState('documents')

  const documents = [
    { name: 'Passport Scans', id: 'passport' },
    { name: 'CNIC Scans', id: 'cnic' },
    { name: 'Offer Letter', id: 'offer' },
    { name: 'IELTS Score', id: 'ielts' },
    { name: 'Passport Size Pictures', id: 'pictures' },
  ]

  return (
    <div className="mt-6">
      <div className="flex gap-2">
        <button
          className={`px-6 py-3 w-36 text-sm font-medium rounded-t-xl ${activeTab === 'documents'
              ? 'bg-[#FFFBF5] border border-gray-500 border-b-0 '
              : ' bg-gray-200'
            }`}
          onClick={() => setActiveTab('documents')}
        >
          Documents
        </button>
        <button
          className={`px-6 py-3 w-36 text-sm font-medium rounded-t-xl ${activeTab === 'invoice'
              ? 'bg-[#FFFBF5] border border-gray-500 border-b-0 '
              : ' bg-gray-200'
            }`}
          onClick={() => setActiveTab('invoice')}
        >
          Invoice
        </button>
      </div>

      {activeTab === 'documents' && (
        <div className="p-6 space-y-4 bg-[#FFFBF5] border border-[#CAC3BB]">
          {documents.map((doc) => (
            <div key={doc.id} className="flex items-center justify-between">
              <span className={`hover:underline cursor-pointer ${doc.id === "ielts" ? "text-[#DF6E6E]" : "text-blue-500"}`}>
                {doc.name}
              </span>
              <div className="flex gap-2">
                <button className="px-4 py-1 text-sm font-light w-28 text-white bg-[#005787] rounded-full">
                  Edit
                </button>
                <button className="px-4 py-1 text-sm font-light w-28 text-white bg-[#005B96] rounded-full">
                  Download
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {activeTab === 'invoice' && (
        <InvoiceForm/>
      )}

    </div>
  )
}